import { eExternalOrderStatus } from 'ui-toolkit/enums/eExternalOrderStatus';
import { IOrderInformation } from 'ui-toolkit/orders/interfaces/IOrderInformation';

export const getOrderInformation = (externalStatus: eExternalOrderStatus): IOrderInformation => {
  return {
    created: '',
    createdBy: null,
    updated: null,
    status: null,
    externalStatus: externalStatus || null,
    refiDiscount: null,
    fundingDate: null,
    orderLinks: [],
  };
};
